import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';

interface IPopover {
  children: JSX.Element;
  buttonData: any;
}

function PopoverButton({ children, buttonData }: IPopover) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  // Function to open the popover
  const handleOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  // Function to close the popover
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <div onClick={handleOpen}>{buttonData}</div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        className="shadow-default"
      >
        {children}
      </Popover>
    </>
  );
}

export default PopoverButton;
